import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { api } from "@/lib/api";
import { ScoreRing } from "@/components/ScoreRing";
import { ToolLogo } from "@/components/ToolLogo";

export default function Compare() {
  const [params] = useSearchParams();
  const ids = (params.get("ids")||"").split(",").filter(Boolean);
  const [tools, setTools] = useState([]);
  useEffect(()=>{
    Promise.all(ids.map(id => api.get(`/tools/${id}`).then(r=>r.data).catch(()=>null))).then(arr => setTools(arr.filter(Boolean)));
  }, []); // eslint-disable-line

  if (tools.length === 0) return <Layout hideRightPanel><div className="text-center py-20 text-[#5B6478]">Add tools from the directory's "Compare" button.</div></Layout>;

  const rows = [
    ["Wikifi Score", t => <ScoreRing score={t.curio_score}/>],
    ["User Score", t => `${t.user_score ?? "—"} ★ (${(t.user_votes ?? 0).toLocaleString()})`],
    ["Pricing", t => t.price_label],
    ["Free Tier", t => t.has_free_tier ? "Yes" : "No"],
    ["Hidden Gem", t => t.hidden_gem ? "Yes" : "No"],
    ["Top pro", t => t.pros[0]],
    ["Top con", t => t.cons[0]],
    ["Details", t => <Link to={`/tool/${t.slug}`} className="btn-coral !py-1 !px-3 text-xs inline-flex">View entry</Link>],
  ];

  return (
    <Layout hideRightPanel>
      <PageHero
        testId="compare-title"
        eyebrow="Side by Side"
        title={<>Compare <span className="italic">head-to-head.</span></>}
        sub="Scores, pricing, pros and cons — lined up so the winner is obvious."
      />
      <div className="overflow-x-auto curio-card">
        <table className="w-full">
          <thead>
            <tr>
              <th className="p-4 text-left text-[10px] uppercase tracking-widest text-[#5B6478]">Feature</th>
              {tools.map(t=> (
                <th key={t.slug} className="p-4 text-left min-w-[180px]">
                  <Link to={`/tool/${t.slug}`}>
                    <ToolLogo tool={t} size={40} rounded="lg" className="mb-1" />
                    <div className="font-display text-xl font-semibold">{t.name}</div>
                  </Link>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, render])=>(
              <tr key={label} className="border-t border-[#E3E8F0]">
                <td className="p-4 text-xs uppercase tracking-widest text-[#5B6478] font-bold">{label}</td>
                {tools.map(t=> <td key={t.slug} className="p-4 align-top text-sm">{render(t)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
